import { CoreInitiativesCommentsName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getInitiativeComments } from '@api';

export const coreInitiativesCommentsGetAsyncSlice = createGetAsyncSlice({
	name: CoreInitiativesCommentsName,
	receive: true,
	request: true,
	requestHandler: getInitiativeComments,
	retainDataOnRequest: true
});
